<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15L/4B15L.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4B15L 1.5T Gasoline Engine</div>
        <div class="detail-banner-desc">
          The 4B15L engine is developed to meet stricter fuel consumption regulations, deliver better dynamic acceleration performance, and achieve higher cost-effectiveness. As a result, it features high performance and rapid dynamic response；<br />
          The 4B15L engine incorporates advanced technologies such as a VGT turbocharger, 350bar top-mounted direct injection, cylinder head integrated exhaust manifold, DVVT, variable displacement oil pump, thermal management module, and Miller cycle.
        </div>

      </div>
    </div>
    <div class="detail-box">
      <div class="detail-title">Core Parameters</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum power</div>
          <div class="detail-utils-u">130kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum torque</div>
          <div class="detail-utils-u">270N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Thermal efficiency</div>
          <div class="detail-utils-u">37.5%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission standard</div>
          <div class="detail-utils-u">China 6b</div>
        </div>

      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">VGT Turbocharger</div>
          <div class="detail-four-desc">
            Compared with conventional electronically controlled wastegate turbochargers, the VGT (Variable Geometry Turbocharger) extends the low-end torque band, significantly enhances dynamic responsiveness, and also improves the fuel consumption rate under partial-load and high-speed, high-load conditions.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">350-bar Central Direct Injection</div>
          <div class="detail-four-desc">
            The center-mounted injector reduces fuel wall-wetting and avoids oil dilution. The 350bar fuel injection system effectively reduces fuel spray diameter and accelerates fuel atomization. It enables triple injection, thereby reducing PN (particulate number) emissions.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-2.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-box detail-bottom-bgs">
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">Cylinder‑Head‑Integrated Exhaust Manifold</div>
          <div class="detail-updown-desc">
            Reducing the number of components helps streamline the structure, resulting in a 23% weight reduction. Engine exhaust gas temperature can be lowered by approximately 100°C. This design makes full use of exhaust heat to rapidly increase engine coolant temperature, shortening warm-up time, reducing fuel consumption and emissions.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">Variable Displacement Oil Pump.</div>
          <div class="detail-updown-desc">
            It can adjust oil pressure based on engine speed and load, reducing fuel consumption by 0.5% to 2%. Under high‑speed conditions, fuel consumption can be reduced by up to 3%.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-4.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-swiper-list detail-box">
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">Thermal Management Module</div>
            <div class="detail-tab-desc">
              It raises oil and cylinder liner temperatures to reduce frictional work, thereby lowering fuel consumption.<br />
              In low‑temperature conditions, it increases oil temperature to mitigate fuel dilution in the oil.<br />
              During cold starts, it rapidly elevates combustion chamber wall temperatures to optimize combustion and reduce emissions.<br />
              Under full engine load, it maintains coolant temperatures at a lower level to minimize pre‑ignition and knocking.
            </div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">Miller Cycle</div>
            <div class="detail-tab-desc">
              By closing the intake valve earlier, the throttle opening is increased, which reduces pumping losses and improves fuel economy at medium and low loads.<br />
              It achieves an effective compression ratio lower than the effective expansion ratio, thereby enhancing thermal efficiency and reducing fuel consumption.<br />
              When paired with a VGT (Variable Geometry Turbocharger), it effectively mitigates knocking tendency and further improves fuel economy.
            </div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15L/4B15L-5.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15L/4B15L-6.jpg" alt=""></div>
        </div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4B15L 1.5T Gasoline Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4B15L.html'
};

import { createApp } from 'vue';
import App from './4B15L.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4B15L.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>